import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PhoneIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PhoneIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.3177 21.6929C14.7239 21.6929 10.4461 21.021 6.71464 17.2896C2.69316 13.2681 2.03496 8.76222 2.00029 6.43459C1.98418 5.38723 2.63994 4.42482 3.63261 4.04055L8.02372 2.34035C8.27128 2.2466 8.54618 2.35744 8.65751 2.59523L11.4764 8.63625C11.5682 8.83254 11.5228 9.06545 11.3641 9.2134L10.1146 10.3784C9.92314 10.5567 9.89141 10.8477 10.0394 11.0703C10.4124 11.6323 10.8533 12.1685 11.3484 12.6636C11.824 13.1392 12.3416 13.5596 12.887 13.9131C13.1058 14.0542 13.3846 14.0274 13.5638 13.8457L15.1033 12.2886C15.2513 12.1387 15.4788 12.0972 15.6702 12.187L21.7112 15.0064C21.9495 15.1177 22.0608 15.3941 21.9661 15.6392L20.2684 20.0435C19.9041 20.9878 19.0203 21.6284 18.0169 21.6763C17.8006 21.6865 17.5667 21.6929 17.3177 21.6929ZM7.94902 3.44191L3.99394 4.97316C3.38994 5.20705 2.99052 5.7881 3.00029 6.41945C3.03252 8.59621 3.6497 12.8106 7.42168 16.5825C11.2391 20.3999 15.6697 20.791 17.969 20.6773C18.5774 20.6485 19.1136 20.2583 19.3357 19.6836L20.8655 15.7154L15.5667 13.2422L14.2752 14.5489C13.7679 15.0616 12.9544 15.148 12.3436 14.7525C11.7391 14.3604 11.1663 13.8955 10.6414 13.3706C10.0994 12.8291 9.61651 12.2412 9.20586 11.6236C8.78691 10.9912 8.88213 10.1602 9.43291 9.647L10.4163 8.73001L7.94902 3.44191Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PhoneIcon;
